/** 
 * @description        组件相关配置
 * @autor              shuxiaokai
 * @create             2020-04-30 08:31
 */

import sampleBatchWidget from "./sample-batch"
import sampleEnterprise from "./sample-enterprise"

export default {
    state: {
        wrapConfig: { //包裹框信息
            boundingClientRect: {
                left: 0, //相对视口left
                top: 0, //相对视口top
                width: 0, //宽度
                height: 0, //高度                
            },
        },
        widgetConf: { //widget配置信息
            id: "",
            type: "",
            boundingClientRect: {
                left: 0, //相对视口素left
                top: 0, //相对视口素top
                width: 0, //宽度
                height: 0, //高度
                clientLeft: 0, //相对于父元素left
                clientTop: 0, //相对于父元素top                
            },
            //=====================================样式相关配置====================================//
            color: "", //全局颜色
            backgroundColor: "", //全局背景颜色
            textStyle: { //全局字体配置
                color: "#45a",
                fontSize: 16,
            }, 
            //=====================================组件独特配置====================================//
            config: {

            },
        },
        widgetList: [], //画布上面所有widget
        selectWidgetId: "", //当前选中的widget id
    },
    mutations: {
        //=====================================拖拽时候widget====================================//
        //改变widget类型
        changeDragWidgetType(state, type) {
            state.widgetConf.type = type;
        },
        //改变拖拽时候组件位置和宽高信息
        changeDragWidgetBoundingClientRect(state, payload) {
            state.widgetConf.boundingClientRect.left = payload.left;
            state.widgetConf.boundingClientRect.top = payload.top;
            state.widgetConf.boundingClientRect.width = payload.width;
            state.widgetConf.boundingClientRect.height = payload.height;
        },
        //重置拖拽的widget
        resetDragWidgetBoundingCLientRect(state) {
            state.widgetConf.boundingClientRect.left = 0;
            state.widgetConf.boundingClientRect.top = 0;
            state.widgetConf.boundingClientRect.width = 0;
            state.widgetConf.boundingClientRect.height = 0;
        },
        //=====================================非拖拽widget====================================//
        //添加组件选中状态
        changeSelectWidgetId(state, id) {
            state.selectWidgetId = id;
        },
        //改变组件位置和宽高信息
        changeWidgetBoundingClientRect(state, payload) {
            const { id, left, top, width, height } = payload;
            const currentWidget = state.widgetList.find(val => val.id === id);
            if (!currentWidget) {
                console.warn(`未找到id为${id}组件`);
                return;
            }
            if (left) {
                currentWidget.boundingClientRect.left = left;
                currentWidget.boundingClientRect.clientLeft = left - state.wrapConfig.boundingClientRect.left;
            }
            if (top) {
                currentWidget.boundingClientRect.top = top;
                currentWidget.boundingClientRect.clientTop = top - state.wrapConfig.boundingClientRect.top;
            }
            if (width) {
                currentWidget.boundingClientRect.width = width;
            }
            if (height) {
                currentWidget.boundingClientRect.height = height;
            }
        },
        //=====================================包裹框====================================//
        //改变包裹框信息
        changeWrapBoundingClientRect(state, payload) {
            state.wrapConfig.boundingClientRect.left = payload.left;
            state.wrapConfig.boundingClientRect.top = payload.top;
            state.wrapConfig.boundingClientRect.width = payload.width;
            state.wrapConfig.boundingClientRect.height = payload.height;
        },
        //通过id删除组件
        deleteWidgetById(id) {

        },
        //=====================================新增不同类型组件====================================//
        //新增一个卡片widget
        addCardWidget(state, payload) {
            console.log(payload)
            const widget = {
                id: String(Date.now()),
                type: payload.type,
                boundingClientRect: {
                    left: payload.left, //相对父元素left
                    top: payload.top, //相对父元素top
                    width: payload.width, //宽度
                    height: payload.height, //高度
                    clientLeft: payload.clientLeft, //相对于父元素left
                    clientTop: payload.clientTop, //相对于父元素top                
                },
                //=====================================样式相关配置====================================//
                backgroundColor: "", //全局背景颜色
                textStyle: { //全局字体配置
                    color: "",
                    fontSize: 16,
                }, 
                //=====================================组件独特配置====================================//
                config: {

                },
            };
            state.widgetList.push(widget);
        },
        //=====================================组件注入====================================//
        ...sampleBatchWidget, //抽样批次数组件
        ...sampleEnterprise, //被抽样单位数量
    }
}
